import { Project } from '@mb/types';
import moment from 'moment';
import { createDeepEqualSelector } from './';

export const projectsSelector = (state: any) => state.projects;

moment().utc().format('YYYY-MM-DD HH:mm:ss');

export const projectsListSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) =>
    projects.projectsList
      ?.filter((project: Project) => !project.is_archived)
      ?.sort(
        (a: Project, b: Project) =>
          moment(a.updated_at).valueOf() - moment(b.updated_at).valueOf(),
      ) || [],
);

export const isProjectModalOpenSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) => projects.isProjectModalOpen,
);

export const projectModalEventLocationSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) => projects.projectModalEventLocation,
);
